import State from 'store/State';
import { useSelector } from 'react-redux';
import { selectAppState } from '../selectors';
import { WellKnownFeatureToggleKeys } from './FeatureTogglesState';

export const selectFeatureTogglesState = (state: State) =>
    selectAppState(state).featureToggles;

const selectFeatureToggleState = (state: State, feature: string) =>
    selectFeatureTogglesState(state)[feature];

export const selectIsFeatureEnabled: (
    state: State,
    feature: string
) => boolean = (state, feature) => {
    let result = selectFeatureToggleState(state, feature);
    if (
        result === undefined &&
        feature !== WellKnownFeatureToggleKeys.EnableIfKeyMissing
    ) {
        result = selectFeatureToggleState(
            state,
            WellKnownFeatureToggleKeys.EnableIfKeyMissing
        );
    }

    if (result === undefined) {
        result = true;
    }

    return result;
};

export const selectIsFeatureDisabled = (state: State, feature: string) =>
    !selectIsFeatureEnabled(state, feature);

export const useSelectIsFeatureEnabled = (feature: string) =>
    useSelector((state: State) => selectIsFeatureEnabled(state, feature));

export const useSelectIsFeatureDisabled = (feature: string) =>
    useSelector((state: State) => selectIsFeatureDisabled(state, feature));
